import _ from 'lodash';
import filters from '../filters';

export default {
    SET_USER(state, user = {}) {
        state.user = user;
        state.locale = user.language;
    },
    SET_USERS(state, users) {
        state.users = users.map(user => {
            return {
                name: `${user.name} ${user.surname}`,
                email: user.email,
                id: user.id,
                userGroups: user.userGroups,
                profilePic: user.profilePic,
                firstname: user.name,
                surname: user.surname,
                status: user.status,
                language: user.language,
                jobTitle: user.jobTitle,
                department: user.department,
                signupDate: user.signupDate,
                lastLoginDate: user.lastLoginDate,
                disableDate: user.disableDate,
                inviteDate: user.inviteDate,
                inviteCount: user.inviteCount,
                avatarId: user.avatarId
            };
        });
    },
    SET_LOCALE(state, locale) {
        state.locale = locale ? locale : 'tr';
    },
    SET_LOCALE_FORCE(state, locale){
        state.locale = locale ? locale : 'tr';
        localStorage.setItem('locale', locale);
        location.reload(true);
    },
    SET_ANALYSIS_UNIT(state, analysis_unit) {
        state.analysis_unit = _.get(_.first(analysis_unit), "name");
    },
    SET_MODAL(state, info) {
        state.modal.eventId = info.eventId;
        state.modal.type = info.type;
        state.modal.text = info.text;
        state.modal.payload = info.payload;
    },
    SET_SITES(state, sites = []) {
        state.sites = sites.map(site => {
            /*
            let modifiedTags = [];

            for (let key in site.tags) {
                modifiedTags.push({
                    key: key,
                    label: site.tags[key],
                    active: false
                });
            }
*/
            return {
                id: site.id,
                siteGroupId: site.siteGroupId,
                typeId: site.typeId,
                name: site.code + ' - ' + filters.capitalizeFirstLetter(site.name),
                originalName: filters.capitalizeFirstLetter(site.name),
                code: site.code,
                cityCode: site.city,
                dataTypes: site.dataTypes,
                tags: state.topLevelTags, // modifiedTags,
                lat: site.lat,
                lng: site.lon,
                phone: site.phoneNumber,
                address: site.address,
                supervisors: site.supervisor ? site.supervisor : null,
                supervisorIds: site.supervisorIds ? site.supervisorIds : null,
                directors: site.director ? site.director : null,
                directorIds: site.directorIds ? site.directorIds : null,
                agents: site.agent ? site.agent : null,
                agentIds: site.agentIds ? site.agentIds : null,
                subAgents: site.subAgent ? site.subAgent : null,
                subAgentIds: site.subAgentIds ? site.subAgentIds : null,
                calculateEmission: site.calculateEmission ? 1 : 0,
                heatingDataType: site.heatingDataType,
                isOpen: site.isOpen ? 1 : 0,
                yearlyProperties: site.properties,
                lastUpdatedAt: site.lastUpdatedAt
            };
        });
    },
    SET_PAYMENT_METHODS(state, paymentMethods) {
        state.paymentMethods = paymentMethods.map(paymentMethod => {
            return {
                value: paymentMethod.id,
                text: paymentMethod.text
            };
        });
    },
    SET_SITE_GROUPS(state, siteGroups) {
        state.siteGroups = siteGroups.map(siteGroup => {
            siteGroup.display_name = filters.capitalizeFirstLetter(siteGroup.display_name);
            return siteGroup;
        });
    },
    SET_SITES_WITH_GROUPS(state){
        let siteMap = [];

        _.each(state.siteGroups, siteGroup=>{
            let cities = [];

            let citiesWithSites = _.groupBy(state.sites.filter(site => {return site.siteGroupId === siteGroup.id;}), 'cityCode');

            _.each(citiesWithSites, (sites,cityId)=>{
                let city = _.find(state.cities, {code: cityId});

                let childSites = [];
                _.each(sites, site=>{
                    if(city===undefined){
                        cities.push({id:"site-"+_.toString(site.id), label:site.name});
                    }else{
                        childSites.push({id:"site-"+_.toString(site.id), label:site.name});
                    }
                });
                                
                if(city!==undefined){
                    cities.push({
                        id:"city-"+_.toString(siteGroup.id)+"-"+city.code,
                        label: city.name,
                        children:childSites
                    });
                }
            });
            
            let newSiteGroup = {id:"region-"+_.toString(siteGroup.id), label:siteGroup.name, children:cities};
            siteMap.push(newSiteGroup);
        });

        state.sitesWithGroups = siteMap;
    },
    SET_DATA_TYPES(state, dataTypes = []) {
        state.dataTypes = dataTypes;
    },
    SET_SOURCE_TYPES(state, sourceTypes = []) {
        state.sourceTypes = sourceTypes;
    },
    SET_TOP_LEVEL_TAGS(state, topLevelTags = []) {
        let modifiedTags = [];
        _.each(topLevelTags, tag =>
            modifiedTags.push({
                key: tag.name,
                label: tag.description,
                active: false
            })
        );
        state.topLevelTags = modifiedTags;
    },
    SET_DOCUMENTS(state, documents = []) {
        state.documents = documents;
    },
    SET_AUDITS(state, audits = []) {
        state.audits = audits;
    },
    SET_UNITS(state, units = []) {
        state.units = units;
        state.unitMap = _.keyBy(units, 'id');
    },
    /*
    SET_ADMIN_LIST(state, agentList = []) {
        state.agentList = agentList;
    },
    */
    SET_UNSUITABLENESS(state, nonconformances = []) {
        state.nonconformances = nonconformances;
    },
    SET_MAX_UPDATED_AT_FOR_DOCUMENTS(state, maxUpdatedAt) {
        state.maxUpdatedAtForDocuments = maxUpdatedAt;
    },
    SET_GOALS(state, goals = []) {
        state.goals = goals;
    },
    SET_MAX_UPDATED_AT_FOR_GOALS(state, maxUpdatedAt) {
        state.maxUpdatedAtForGoals = maxUpdatedAt;
    },
    SET_MAX_UPDATED_AT_FOR_AUDIT(state, maxUpdatedAt) {
        state.maxUpdatedAtForAudits = maxUpdatedAt;
    },
    SET_TICKET_LIST(state, ticketList) {
        state.ticketList = ticketList;
    },
    SET_FORM_TYPES(state, formTypes = []) {
        state.formTypes = formTypes;
    },
    SET_SITE_TYPES(state, siteTypes = []) {
        state.siteTypes = siteTypes;
    },
    SET_DASHBOARD_DATA_TYPES(state, dashboardDataTypes = []) {
        state.dashboardDataTypes = dashboardDataTypes;
    },
    SET_LOCATIONS_AND_SECTORS(state, locationsAndSectors = []) {
        state.countryMap = _.keyBy(_.get(locationsAndSectors, 'countries'), o=>o.id)
        state.regionMap = _.keyBy(_.get(locationsAndSectors, 'regions'), o=>o.id)
        state.cityMap = _.keyBy(_.get(locationsAndSectors, 'cities'), o=>o.id)
        state.sectorMap = _.keyBy(_.get(locationsAndSectors, 'sectors'), o=>o.id)

        let locationMap = [];
        _.each(state.countries, country =>{
            let regionMap = []
            _.each(_.filter(state.regions, region=> region.countryId == country.id), region=>{
                regionMap.push({id:_.toString(region.id), label:region.name});
            })
            locationMap.push({
                id:_.toString(country.id),
                label: country.name,
                children:regionMap
            });
            
        })
        state.locationMap = locationMap
    },
    SET_RELATIONAL_TAGS(state, relationalTags = []) {
        state.tagMap = _.get(relationalTags, 'relationMap');
        state.scopeGroupMap = _.get(relationalTags.alltags, 'scope-group')
        state.sourceTypeGroupMap = _.get(relationalTags.alltags, 'source-type-group')
        state.sourceTypeMap = _.get(relationalTags.alltags, 'source-type')
    },
    SET_AWS_OPTIONS(state, isExcludedForAws=false){
        state.isExcludedForAws = isExcludedForAws;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js